export default "/images/12709840078b0e545781bd6dfd7eec92.avif";